export const AFFINITY_REASONS = {
  teachesClass: 'teaches_class',
  taughtClassOtherYear: 'taught_class_other_year',
  teachesSubject: 'teaches_subject',
  teachesSubjectSameYear: 'teaches_subject_same_year',
} as const

export type AffinityReason = (typeof AFFINITY_REASONS)[keyof typeof AFFINITY_REASONS]

export const AFFINITY_MARK_LABELS: Record<AffinityReason, string> = {
  [AFFINITY_REASONS.teachesClass]: 'unterrichtet die Klasse',
  [AFFINITY_REASONS.taughtClassOtherYear]: 'Klasse in anderem Lehrjahr',
  [AFFINITY_REASONS.teachesSubject]: 'unterrichtet das Fach',
  [AFFINITY_REASONS.teachesSubjectSameYear]: 'Fach im selben Lehrjahr',
}

export const AFFINITY_CLASS_REASONS = new Set<AffinityReason>([
  AFFINITY_REASONS.teachesClass,
  AFFINITY_REASONS.taughtClassOtherYear,
])

export const AFFINITY_SUBJECT_REASONS = new Set<AffinityReason>([
  AFFINITY_REASONS.teachesSubject,
  AFFINITY_REASONS.teachesSubjectSameYear,
])
